import React from 'react';
import {PageHeader, PageTitle} from '@cjdev/visual-stack/lib/components/PageHeader';
import PageContent from '@cjdev/visual-stack/lib/components/PageContent';


const HomePage = () => (
    <React.Fragment>
        <PageHeader>
            <PageTitle>CJ Engineering Operations</PageTitle>
        </PageHeader>
        <PageContent>
            <h2>CJ Engineering Operations Home</h2>
            <p>
                Applications to monitor, manage, troubleshoot, and audit CJ Engineering operations
                in the cloud and own data centers.
            </p>
        </PageContent>
    </React.Fragment>
);

export {HomePage};



// WEBPACK FOOTER //
// ./src/view/HomePage.js